import { render, staticRenderFns } from "./SchoolHome.vue?vue&type=template&id=b97d334c&scoped=true"
import script from "./SchoolHome.vue?vue&type=script&lang=js"
export * from "./SchoolHome.vue?vue&type=script&lang=js"
import style0 from "./SchoolHome.vue?vue&type=style&index=0&id=b97d334c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b97d334c",
  null
  
)

export default component.exports